export default "__VITE_ASSET__dU_Zp0a7h267LjUI_0xdjw__"